<template lang="pug">
  .column.landing-container
    .section-title.column.center.middle.relative.m4-bottom-15
      img.absolute.yellow-triangle(src='../assets/landing/howItWorks/shape_landing_comofunciona_2.svg')
      img.absolute.dots-grid(src='../assets/landing/howItWorks/shape_landing_comofunciona_1.svg')
      img.absolute.gray-block(src='../assets/landing/howItWorks/shape_landing_comofunciona_7.svg')
      img.absolute.blue-block.hide-mobile(src='../assets/landing/howItWorks/shape_landing_comofunciona_6.svg')
      img.absolute.dashed-gray-point(src='../assets/landing/howItWorks/shape_landing_comofunciona_3.svg')
      .title-container.z-index-1
        h1.title-xlbig.black.title.text-center
          | {{ $t('content.title') }}
    .section-categories.column.center
      .row.center.space-between.max-width.m4-bottom-23.upper-container
        .text-container.column
          h3.title-xbig.bolder.m4-bottom-6.z-index-1.responsive-title.blue
            | {{ $t('content.categoriesTitle') }}
          p.text-xbig.description.z-index-1.cat-description
            | {{ $t('content.categoriesDescription') }}
        .bg-image.hide-mobile
          lottie(:options='weApproachTheClassroomOptions' :style='weApproachStyles')
      .row.m-bottom-5.categories-container
        category-card(categoryName='computationalThinking' :source='computationalThinking')
        category-card(categoryName='globalCitizenship' :source='globalCitizenship')
        category-card(categoryName='entrepreneurialSpirit' :source='entrepreneurialSpirit')
    .section-categories.column.center
      .row.center.space-between.max-width.m4-bottom-23.upper-container.responsive-ods-container
        .text-container.column
          h3.title-xbig.bolder.m4-bottom-6.z-index-1.responsive-title.blue
            | {{ $t('content.odsTitle') }}
          .row.middle.responsive-ods-container
            img.self-center.ods-img(:src='require(`../assets/landing/ods_${language}.png`)')
            span.text-xbig.z-index-1.cat-description.item-1.ods-subtitle-container
              | {{ $t('content.odsSubtitle') }}
    .section-skills.row.center.relative.m-bottom-5
      img.absolute.grid-with-dot.hide-mobile(src='../assets/landing/howItWorks/shape_landing_comofunciona_4.svg')
      .column.left-container.m4-right-30.z-index-1.skills-container
        h3.title-xbig.bolder.m4-bottom-6.responsive-title.blue
          | {{ $t('content.skillsTitle') }}
        .row.middle.m4-bottom-15.hide-mobile
          img(src='../assets/schools/ic_saberes_cross.svg' alt='saberes')
          svg(height='22' width='278')
            path.lines-moving(opacity='1' fill-rule='evenodd' d='M9.409260218956888,9.409260218956888 L269.4092602189569,9.409260218956888')
        span.text-xbig.paragraph.m4-bottom-16
          | {{ $t('content.skillsDescription') }}
      .column.right-container.z-index-1
        .skills-list.column.wrap
          img.skills-graphic(:src='require(`../assets/landing/skills_graphic_${language}.png`)')
      img.absolute.diamond-with-block(src='../assets/landing/howItWorks/shape_landing_comofunciona_5.svg')
    .section-authors.column.center.relative(v-if='false')
      img.absolute.big-dotted-grid(src='../assets/landing/howItWorks/shape_landing_comofunciona_8.svg')
      img.absolute.dashed-rectangle(src='../assets/landing/howItWorks/shape_landing_comofunciona_12.svg')
      .upper-container.column.max-width.m4-bottom-16
        h3.title-big.bolder.m4-bottom-6
            | {{ $t('content.authorsTitle') }}
        p.text-xbig.author-description(v-html='$t("content.authorsDescription")')
      .author-carousel.row.center.middle.relative.m-bottom-5
        button.arrow-container.arrow-left(v-if='showPrevArrow' type='button' @click='prevSlide')
          simple-svg.arrow.dark-gray-hover-blue(:filepath='arrowLeft' :width='"20px"' :height='"20px"')
        button.arrow-container.arrow-right(v-if='showNextArrow' type='button' @click='nextSlide')
          simple-svg.arrow.dark-gray-hover-blue(:filepath='arrowRight' :width='"20px"' :height='"20px"')
        .row
          button(@click='() => openVideoModal("https://player.vimeo.com/video/350322362")')
            small-card.small-card.m-right-5(:image='authorImages.kimple' :cardNumber='1' v-if='showCard(1)')
          button(@click='() => openVideoModal("https://www.youtube.com/embed/x46rmQVYPNw")')
            small-card.small-card.m-right-5(:image='authorImages.ypd' :cardNumber='2' v-if='showCard(2)')
          button(@click='() => openVideoModal("https://www.youtube.com/embed/GZ9jgbr-HMg")')
            small-card.small-card(:image='authorImages.wll' :cardNumber='3' v-if='showCard(3)')
          button(@click='() => openVideoModal("https://player.vimeo.com/video/453271976")')
            small-card.small-card.m-right-5(:image='authorImages.ecohouse' :cardNumber='4' v-if='showCard(4)')
          button(@click='() => openVideoModal("https://player.vimeo.com/video/438657276")')
            small-card.small-card.m-right-5(:image='authorImages.newtral' :cardNumber='5' v-if='showCard(5)')
          button(@click='() => openVideoModal("https://player.vimeo.com/video/454760229")')
            small-card.small-card(:image='authorImages.mentesInquietas' :cardNumber='6' v-if='showCard(6)')
          button(@click='() => openVideoModal("https://player.vimeo.com/video/447474885")')
            small-card.small-card.m-right-5(:image='authorImages.lab' :cardNumber='7' v-if='showCard(7)')
          button(@click='() => openVideoModal("https://player.vimeo.com/video/448873647")')
            small-card.small-card.m-right-5(:image='authorImages.garaje' :cardNumber='8' v-if='showCard(8)')
          small-card.small-card(:image='authorImages.fad' :cardNumber='9' v-if='showCard(9)')
          small-card.small-card.m-right-5(:image='authorImages.laferrereAndFernandezCisneros' :cardNumber='10' v-if='showCard(10)')
          small-card.small-card.m-right-5(:image='authorImages.holocaustMemorialDayTrust' :cardNumber='11' v-if='showCard(11)')
          small-card.small-card(:image='authorImages.standUpEducationAgainstDiscrimination' :cardNumber='12' v-if='showCard(12)')
          small-card.small-card.m-right-5(:image='authorImages.LicSilviaHurrell' :cardNumber='13' v-if='showCard(13)')
          small-card.small-card.m-right-5(:image='authorImages.InspiringFC' :cardNumber='14' v-if='showCard(14)')
          small-card.small-card(:image='authorImages.earthEcho' :cardNumber='15' v-if='showCard(15)')
      button.request-demo.primary-button.m-bottom-6(@click='handleCatalogue')
        | {{ $t('content.fullAccess') }}
    video-modal(v-if='showVideoModal' :videoUrl='videoUrl' @close='closeVideoModal')
    view-catalogue-modal(v-if='showViewCatalogueModal')
    vue-headful(:title='contentMeta.title', :description='contentMeta.description')
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Lottie from 'vue-lottie'

import CategoryCard from '../components/Landing/CategoryCard'
import SmallCard from '../components/Landing/SmallCard'
import VideoModal from '@/components/EducationalPrograms/VideoModal'

import computationalThinking from '@/assets/landing/lottie/computationalThinking.json'
import globalCitizenship from '@/assets/landing/lottie/globalCitizenship.json'
import entrepreneurialSpirit from '@/assets/landing/lottie/entrepreneurialSpirit.json'
import weApproachTheClassroom from '@/assets/landing/lottie/weApproachTheClassroom.json'
import arrowLeft from '@/assets/ic_chevron-left.svg'
import arrowRight from '@/assets/ic_chevron-right.svg'
import CarouselComp from '@/components/Carousel'

import { authorImages } from '../utils/constants'
import { contentMeta } from '../constants/metaInfo'
import { weApproachStyles } from '../scss/lottie/howItWorks'
import colors from '../scss/variables/_colors.scss'
import { routes } from '../router'
import resize from '../mixins/resize'
import ViewCatalogueModal from '@/components/Modals/ViewCatalogueModal'

export default {
  name: 'content',
  components: { CategoryCard, SmallCard, Lottie, CarouselComp, VideoModal, ViewCatalogueModal },
  mixins: [ resize ],
  data() {
    return {
      computationalThinking,
      globalCitizenship,
      entrepreneurialSpirit,
      authorImages,
      arrowLeft,
      arrowRight,
      weApproachStyles,
      weApproachTheClassroomOptions: { animationData: weApproachTheClassroom },
      colors,
      currentAuthorPage: 0,
      showVideoModal: false,
      videoUrl: '',
      contentMeta
    }
  },
  computed: {
    ...mapState({
      language: state => state.behavior.locale,
      showViewCatalogueModal: state => state.behavior.viewCatalogueModal.show
    }),
    showNextArrow() {
      return this.isMobile ? this.currentAuthorPage < 7 : this.currentAuthorPage < 4
    },
    showPrevArrow() {
      return this.currentAuthorPage > 0
    }
  },
  methods: {
    ...mapActions(['showElement']),
    prevSlide() {
      this.currentAuthorPage -= 1
    },
    nextSlide() {
      this.currentAuthorPage += 1
    },
    createTrial() {
      this.$router.push({ name: routes.trial })
    },
    showCard(cardIndex) {
      if (this.isMobile) {
        return this.currentAuthorPage + 1 === cardIndex
      }
      return this.currentAuthorPage + 1 === Math.ceil(cardIndex / 3)
    },
    closeVideoModal() {
      this.showVideoModal = false
    },
    openVideoModal(videoUrl) {
      this.videoUrl = videoUrl
      this.showVideoModal = true
    },
    handleCatalogue() {
      this.showElement({ element: 'viewCatalogueModal' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';
@import 'src/scss/common/animations';
@import 'src/scss/variables/sizes';

.ods-img {
  padding: 20px;
  max-width:350px;
}

.ods-subtitle-container {
  max-width: 800px;
}

.landing-container {
  overflow: hidden;
}

.request-demo {
  max-width: 500px;
}

.section-title {
  height: 586px;

  .yellow-triangle {
    height: 340px;
    width: 340px;
  }

  .dots-grid {
    height: 64px;
    width: 216px;
  }

  .gray-block {
    height: 292px;
    width: 324px;
  }

  .blue-block {
    height: 132px;
    width: 132px;
  }

  .dashed-gray-point {
    height: 168px;
    width: 198px;
  }
}

.section-authors {
  .author-carousel {
    .arrow-left {
      left: -20px;
      z-index: 2;
    }

    .arrow-right {
      right: -20px;
      z-index: 2;
    }
  }
}

.title {
  max-width: 810px;
}

.max-width {
  max-width: 1176px;
  width: 100%;
}

.description {
  max-width: 484px;
}

.skills-container {
  max-width: 550px;
}

.section-categories {
  background: $white url('../assets/landing/howItWorks/shape_landing_comofunciona_back.svg') center 360px no-repeat;
  background-size: cover;
  padding-top: 50px;

  .bg-image {
    background: url('../assets/landing/howItWorks/shape_landing_comofunciona_11.svg') 30px top no-repeat;
    height: 254px;
    width: 492px;
  }
}

.section-image {
  background-color: $light-gray;
  padding-top: 50px;
}

.section-authors {
  padding: 124px 0 84px;

  .author-description {
    max-width: 750px;
  }
  .big-dotted-grid {
    height: 144px;
    width: 248px;
  }
}

.section-programs {
  background-color: $lightest-gray;
  padding: 76px 0;

  .image {
    width: 600px;
  }
}

.section-carousel {
  background-color: $lightest-gray;
  padding: 44px 0 56px;
}

.section-skills {
  padding: 50px 0 124px 0;

  .skill-image {
    max-width: 400px;
  }

  .skills-graphic {
    max-width: 516px;
  }

  .diamond-with-block {
    bottom: 30px;
    right: 0;
  }

  .right-container {
    max-width: 580px;

    .paragraph {
      max-width: 516px;
    }

    .skills-list {
      max-height: 240px;
    }
  }
}

.section-metrics {
  padding: 48px 0;

  .text-width {
    max-width: 350px;
  }

  .image {
    max-width: 580px;
  }
}

.z-index-1 {
  z-index: 1;
}

// Absolutes

.yellow-triangle {
  right: 0;
  top: 0;
}

.dots-grid {
  right: 152px;
  top: 96px;
}

.blue-block {
  left: 256px;
  top: 104px;
}

.gray-block {
  left: 0;
  top: 136px;
}

.dashed-gray-point {
  bottom: 52px;
  left: calc(50% + 244px);
}

.big-dotted-grid {
  right: -12px;
  top: 54px;
}

.dashed-rectangle {
  bottom: 128px;
  left: 0;
  z-index: -1;
}

.grid-with-dot {
  left: 0;
  top: 60px;
}

.dots-grid-2 {
  bottom: 412px;
  right: -62px;
}

.lines-moving {
  animation: dash 1.5s linear infinite;
  fill-opacity: 0;
  stroke: $gray;
  stroke-dasharray: 30;
  stroke-dashoffset: 30;
  stroke-linecap: butt;
  stroke-linejoin: miter;
  stroke-opacity: 1;
  stroke-width: 7px;
}

// Images carousel

.carousel {
  max-width: 334px;
}

.small-card {
  height: 200px;
}

// Responsive

@media screen and (max-width: $mobile-break) {

  .ods-img {
    max-width:250px;
    align-self: flex-start;
    padding: 0 0 30px 0;
  }

  .categories-container {
    flex-direction: column;
  }

  .responsive-ods-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
  }

  .responsive-title {
    font-size: 24px;
    font-weight: bold;
    line-height: 29px;
    margin-bottom: 16px;
  }

  .responsive-subtitle {
    font-size: 21px;
    font-weight: bold;
    line-height: 25px;
  }

  .responsive-description {
    font-size: 20px;
    font-weight: 300;
    line-height: 27px;
    margin-bottom: 24px;
  }

  .align-container {
    max-width: 324px;
    width: 100%;
  }

  .small-card {
    margin-right: 0;
  }

  .section-title {
    height: 276px;
    justify-content: flex-start;
    margin: 0;
    padding: 32px 24px;

    .yellow-triangle {
      height: 136px;
      right: -20px;
      width: 136px;
    }

    .dots-grid {
      height: 28px;
      right: 36px;
      top: 28px;
      width: 88px;
    }

    .gray-block {
      height: 136px;
      left: -60px;
      top: 64px;
      width: 152px;
    }

    .dashed-gray-point {
      height: 72px;
      left: auto;
      right: 88px;
      top: 144px;
      width: 88px;
    }

    .title-container {
      max-width: 324px;
      width: 100%;

      .title {
        font-size: 30px;
        line-height: 36px;
        max-width: 292px;
        text-align: left;
      }
    }
  }

  .section-categories {
    background-position-y: 296px;
    background-size: contain;
    overflow: hidden;
    padding: 0 8px;

    .upper-container {
      justify-content: center;
      margin-bottom: 28px;
      padding: 0 16px;

      .text-container {
        @extend .align-container;
        align-items: flex-start;

        .cat-description {
          @extend .responsive-description;
          max-width: 308px;
        }
      }
    }

    .cat-carousel-container {
      display: block;
      max-width: 360px;
      width: 100%;

      .cat-carousel {
        margin-bottom: 36px;
      }
    }
  }

  .section-image {
    padding: 0 20px;

    .title {
      @extend .responsive-subtitle;
      margin-bottom: 32px;
    }

    .image {
      max-width: 320px;
      width: 100%;
    }
  }

  .section-authors {
    padding: 60px 12px;

    .big-dotted-grid {
      height: 72px;
      right: 0;
      top: 288px;
      width: 120px;
    }

    .dashed-rectangle {
      height: 116px;
      left: -48px;
      top: 612px;
      width: 192px;
    }

    .upper-container {
      align-items: center;
      flex-direction: column;
      margin-bottom: 76px;
      padding: 0 12px;

      .text-container {
        @extend .align-container;

        .authors-title {
          @extend .responsive-title;
          max-width: 280px;
        }

        .authors-description {
          @extend .responsive-description;
          margin-bottom: 36px;
          max-width: 320px;
        }
      }

      .image {
        width: 340px;
      }
    }

    .authors-subtitle {
      @extend .responsive-subtitle;
      margin-bottom: 24px;
      max-width: 242px;
      text-align: center;
    }

    .small-cards-container {
      flex-direction: column;

      .small-card:not(:last-child) {
          margin: 0 0 20px;
      }
    }
  }

  .section-programs {
    padding: 48px 12px 0;

    .programs-container {
      flex-direction: column-reverse;
      padding: 0 12px;
      max-width: 364px;
      width: 100%;

      .image {
        @extend .align-container;
        margin: 0;
        max-width: 340px;
        width: 100%;
      }

      .description {
        @extend .align-container;

        .program-description {
          @extend .responsive-description;
          max-width: 316px;
        }
      }
    }
  }

  .section-skills {
    align-items: center;
    flex-direction: column;
    padding: 60px 24px;
    width: 100%;

    .diamond-with-block {
      display: none
    }

    .left-container {
      @extend .align-container;
      margin: 0;
    }

    .right-container {
      @extend .align-container;

      .paragraph {
        @extend .responsive-description;
        max-width: 324px;
      }

      .skills-list {
        flex-wrap: nowrap;
        max-height: none;

        .skill {
          margin-right: 0;
        }
      }
    }
  }

  .section-metrics {
    flex-direction: column;
    padding: 35px 12px 64px;

    .metrics-container {
      flex-direction: column;
      max-width: 348px;
      padding: 0 12px;
      width: 100%;

      .description {
        @extend .align-container;
        margin: 0;

        .metrics-title {
          @extend .responsive-title;
          max-width: 264px;
        }

        .metrics-description {
          @extend .responsive-description;
          max-width: 296px;
        }
      }
    }

    .image {
      width: 340px;
    }
  }

  // Carousel responsive

  .carousel {
    height: 416px;
    max-width: 334px;

    .slide {
      height: 332px;
      max-width: 334px;

      .image-container {
        .image {
          height: 196px;
          margin-bottom: 20px;
          max-width: 268px;
        }
      }

      .text-container {
        font-size: 16px;
        line-height: 19px;
        margin: 0;
        max-width: 336px;
      }
    }
  }

  .arrow-container {
    bottom: 4px;
    top: auto;
  }

  // Categories carousel

  .cat-carousel {
    height: 268px;
    max-width: 328px;
    width: 100%;

    .slide {
      margin-right: 8px;
      max-width: 320px;
      width: 100%;
    }
  }
}
</style>
